import { render, staticRenderFns } from "./FDLists.vue?vue&type=template&id=15c07af0&"
import script from "./FDLists.vue?vue&type=script&lang=js&"
export * from "./FDLists.vue?vue&type=script&lang=js&"
import style0 from "./FDLists.vue?vue&type=style&index=0&id=15c07af0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports